<script>
// import Layout from './components/'
import Flow from './components/Flow'
import Work from './components/Work'
import BestRecruitLayout from './components/MenuList'

export default {
  page() {
    return {
      title: `菁英招募 | 加入零壹`,
    }
  },
  components: {
    Flow,
    Work,
    BestRecruitLayout,
  },
  props: {
    aboutCompany: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
}
</script>
<template>
  <BestRecruitLayout>
    <Flow v-if="aboutCompany" :about-company="aboutCompany"></Flow>
    <Work v-if="aboutCompany" :about-company="aboutCompany"></Work>
  </BestRecruitLayout>
</template>
<style lang="scss" module>
</style>
